import { Alert } from '@/common/components/Alert/Alert';
import { Translate } from '@/common/components/Translate/Translate';
import { IInsurancePolicy } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { getYearsDifferenceFromToday } from '@/common/utils/date';

export function useInsurancePolicyAlert(policy: IInsurancePolicy) {
  const hasPendingPersons = policy.persons.some(
    (person) => person.status === 'pending'
  );

  if (hasPendingPersons) {
    return (
      <Alert type="info">
        <Translate i18nKey="dashboard.insurance.status.pending.alert" />
      </Alert>
    );
  }

  const policyEmployee = policy.persons.find(
    (person) => person.type === 'employee'
  );

  if (policyEmployee) {
    const isEmployeeInsideGracePeriod =
      policyEmployee.status === 'leaving' &&
      policyEmployee.startsOn &&
      getYearsDifferenceFromToday(policyEmployee.startsOn) >= 1;

    if (isEmployeeInsideGracePeriod) {
      return (
        <Alert type="info">
          <Translate i18nKey="dashboard.insurance.status.leaving.alert" />
        </Alert>
      );
    }
  }

  return null;
}
